export function getScreenClass(innerWidth) {
  if (innerWidth < 576) return 'sm';else if (innerWidth >= 576 && innerWidth < 768) return 'md';else if (innerWidth >= 768 && innerWidth < 992) return 'lg';else if (innerWidth >= 992) return 'xl';
}